'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Terms = require('self-service-api/constants/Terms');

var Terms = _interopRequireWildcard(_Terms);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _PriceBreakdownModal = require('pricing-pages-unified-ui/components/calculator/PriceBreakdownModal');

var _PriceBreakdownModal2 = _interopRequireDefault(_PriceBreakdownModal);

var _CalculatorCTAsContainer = require('pricing-pages-unified-ui/components/calculator/CalculatorCTAsContainer');

var _CalculatorCTAsContainer2 = _interopRequireDefault(_CalculatorCTAsContainer);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _CalculatorPriceDisplayTile = require('./CalculatorPriceDisplayTile');

var _CalculatorPriceDisplayTile2 = _interopRequireDefault(_CalculatorPriceDisplayTile);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _Calculator = require('pricing-pages-unified-ui/components/calculator/Calculator');

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _merchUtils = require('self-service-api/core/utilities/merchUtils');

var _ActiveHubSelectors = require('pricing-pages-unified-ui/selectors/ActiveHubSelectors');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HubCalcPriceDisplayTileContainer = function HubCalcPriceDisplayTileContainer(_ref) {
  var _calculateBundlePrice, _getMultiplePriceBrea;

  var activeCurrencyCode = _ref.activeCurrencyCode,
      activeHub = _ref.activeHub,
      pricingDependencies = _ref.pricingDependencies;

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      state = _useContext.state;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  // TODO find a less gross way to do this


  var activeHubMerchKey = activeHub + 'PlanSelected';
  var activeHubUnitsKey = activeHub + 'Units';

  var activeEdition = state.activeEdition,
      activeTerm = state.activeTerm,
      selectedAddOns = state.selectedAddOns,
      selectedServices = state.selectedServices;

  var additionalUnitQuantity = state[activeHubUnitsKey];
  var activeMerchId = (0, _merchUtils.getHighlightedMerchIdForEdition)(activeHub, activeEdition);

  var pricingInfo = (0, _pricingUtils.calculateBundlePrice)((_calculateBundlePrice = {}, _defineProperty(_calculateBundlePrice, activeHubMerchKey, activeMerchId), _defineProperty(_calculateBundlePrice, activeHubUnitsKey, additionalUnitQuantity), _defineProperty(_calculateBundlePrice, 'selectedAddOns', selectedAddOns.toArray()), _defineProperty(_calculateBundlePrice, 'selectedServices', selectedServices.toArray()), _defineProperty(_calculateBundlePrice, 'term', activeTerm), _defineProperty(_calculateBundlePrice, 'pricingDependencies', pricingDependencies), _calculateBundlePrice));

  var allPriceBreakdowns = (0, _pricingUtils.getMultiplePriceBreakdowns)((_getMultiplePriceBrea = {}, _defineProperty(_getMultiplePriceBrea, activeHubMerchKey, activeMerchId), _defineProperty(_getMultiplePriceBrea, activeHubUnitsKey, additionalUnitQuantity), _defineProperty(_getMultiplePriceBrea, 'selectedAddOns', selectedAddOns.toArray()), _defineProperty(_getMultiplePriceBrea, 'selectedServices', selectedServices.toArray()), _defineProperty(_getMultiplePriceBrea, 'pricingDependencies', pricingDependencies), _getMultiplePriceBrea));

  var recurringMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.monthly.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return {
      monthly: breakdown.monthly,
      annually: breakdown.annually
    };
  });

  var oneTimeMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.oneTimeFee.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return breakdown.oneTimeFee;
  });

  var togglePriceBreakdown = function togglePriceBreakdown(isVisible) {
    setModalVisibility(isVisible);

    if (isVisible) {
      (0, _getUsageTracker2.default)().track('clickToViewModal', {
        name: 'price-breakdown-modal'
      });
    }
  };

  var getCostToGetStarted = function getCostToGetStarted() {
    var oneTimeFee = pricingInfo.oneTimeFee.calculatedPrice;

    if (activeTerm === Terms.MONTHLY) {
      return pricingInfo.monthly.calculatedPrice + oneTimeFee;
    }
    if (activeTerm === Terms.ANNUAL) {
      return pricingInfo.annually.calculatedPrice + oneTimeFee;
    }
    return null;
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_CalculatorPriceDisplayTile2.default, {
      gaTrackingId: activeHub,
      activeTerm: activeTerm,
      monthlyCost: pricingInfo.monthly.calculatedPrice,
      costToGetStarted: getCostToGetStarted(),
      activeCurrencyCode: activeCurrencyCode,
      onViewPriceBreakdownClick: (0, _partial2.default)(togglePriceBreakdown, true),
      ctasComponent: _react2.default.createElement(_CalculatorCTAsContainer2.default, {
        activeTerm: activeTerm,
        merchandiseId: activeMerchId,
        additionalUnitQuantity: additionalUnitQuantity
      })
    }),
    isModalVisible && _react2.default.createElement(_PriceBreakdownModal2.default, {
      onCloseClick: (0, _partial2.default)(togglePriceBreakdown, false),
      estimatedCostToGetStarted: getCostToGetStarted(),
      activeTerm: activeTerm,
      activeMerchId: activeMerchId,
      pricingInfo: pricingInfo,
      recurringMerchPriceBreakdown: recurringMerchPriceBreakdown,
      oneTimeMerchPriceBreakdown: oneTimeMerchPriceBreakdown
    })
  );
};

HubCalcPriceDisplayTileContainer.propTypes = {
  activeCurrencyCode: _react.PropTypes.string.isRequired,
  activeHub: _react.PropTypes.oneOf(Object.values(_Hubs2.default || {})),
  pricingDependencies: _react.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state),
    activeHub: (0, _ActiveHubSelectors.activeHubSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcPriceDisplayTileContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcPriceDisplayTileContainer.js
// module id = 338
// module chunks = 3 4